import { render, staticRenderFns } from "./flat-filter.vue?vue&type=template&id=0dbf860d&scoped=true&"
import script from "./flat-filter.vue?vue&type=script&lang=js&"
export * from "./flat-filter.vue?vue&type=script&lang=js&"
import style0 from "./flat-filter.vue?vue&type=style&index=0&id=0dbf860d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbf860d",
  null
  
)

export default component.exports